import React from 'react';
import Logo from 'app/fuse-layouts/shared-components/Logo';
import LanguageSwitcher from 'app/fuse-layouts/shared-components/LanguageSwitcher';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    headerBox:{
        boxShadow: '0px 3px 5px 0px rgba(0,0,0,0.33)',
    }
}))

function HeaderAuth(){
    const classes = useStyles();

    return(
        <div className={clsx("flex flex-row justify-between px-8 drop-shadow-lg", classes.headerBox)}>
            <Logo/>
            <LanguageSwitcher />
        </div>
    )
}

export default HeaderAuth;